// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3790":"ff4a9011","3935":"95ae6095","5184":"0f1ee669","7851":"942290cd"}[chunkId] + ".chunk.css";
};